import { Heading, Text } from '@uhg-harmony/react';
import styles from './Masthead.module.css';

interface MastheadProps {
  subTitle: string;
  mainTitle: string;
  partnerLogoAlt: string;
  partnerLogoHref: string;
}

export function Masthead({ subTitle, mainTitle, partnerLogoAlt, partnerLogoHref }: MastheadProps) {
  return (
    <div className={styles.masthead} role="banner">
      <div className="container">
        {/* DOL seal + Agency/portal title row */}
        <div className={styles.inner}>
          <a
            href="https://www.dol.gov"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="U.S. Department of Labor — external link"
            className={styles.sealLink}
          >
            <img
              src="/assets/images/logo.png"
              alt="U.S. Department of Labor seal"
              className={styles.seal}
            />
          </a>

          {/* Agency sub-line + portal title */}
          <div className={styles.titleBlock}>
            <Heading level="h2" inverse className={styles.agencyName}>U.S. Department of Labor</Heading>
            <Text as="p" inverse className={styles.agencyLine}>{subTitle}</Text>
            <Heading level="h1" inverse className={styles.portalTitle}>{mainTitle}</Heading>
          </div>

          {/* Partner logo (OWCP) */}
          <div className={styles.partnerLogo}>
            <a href={partnerLogoHref || '#'} target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/images/OWCP.png"
                alt={partnerLogoAlt}
                className={styles.optumLogo}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
